var scope_0 = require('/home/runner/work/beauty-religion/beauty-religion/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1793c881cbfe0ed7ee74ec6f66b55745.js').default;
var scope_1 = require('/home/runner/work/beauty-religion/beauty-religion/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4982ccc4255ac04e8132f5747803f849.js').default;
var scope_2 = require('/home/runner/work/beauty-religion/beauty-religion/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/531f8afffe7c29a2bfcb84aacff85d2d.js').default;
var scope_3 = require('/home/runner/work/beauty-religion/beauty-religion/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    